import { render } from "./SpacesEditGroup.vue?vue&type=template&id=1fc0f99d&ts=true"
import script from "./SpacesEditGroup.vue?vue&type=script&lang=ts"
export * from "./SpacesEditGroup.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__